import { render, staticRenderFns } from "./AdminReportBuyersByDate.vue?vue&type=template&id=640c816f"
import script from "./AdminReportBuyersByDate.vue?vue&type=script&lang=js"
export * from "./AdminReportBuyersByDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640c816f')) {
      api.createRecord('640c816f', component.options)
    } else {
      api.reload('640c816f', component.options)
    }
    module.hot.accept("./AdminReportBuyersByDate.vue?vue&type=template&id=640c816f", function () {
      api.rerender('640c816f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReportBuyersByDate.vue"
export default component.exports